import { Component } from '@angular/core';

@Component({
  selector: 'app-attention-info-text-section',
  standalone: true,
  imports: [],
  templateUrl: './attention-info-text-section.component.html',
  styleUrl: './attention-info-text-section.component.scss'
})
export class AttentionInfoTextSectionComponent {

}
